import { Box, CircularProgress, Typography, Stack } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  fullPage?: boolean;
}

export function LoadingSpinner({ message, size = 36, fullPage = false }: LoadingSpinnerProps) {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={
        fullPage
          ? { minHeight: '100vh', bgcolor: 'background.default' }
          : { py: 8, px: 2 }
      }
    >
      <Stack alignItems="center" spacing={2}>
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          {/* Outer ring */}
          <CircularProgress
            variant="determinate"
            value={100}
            size={size + 8}
            thickness={2}
            sx={{ color: 'divider', position: 'absolute', top: -4, left: -4 }}
          />
          <CircularProgress size={size} thickness={3.5} />
        </Box>
        {message && (
          <Typography
            variant="body2"
            color="text.secondary"
            fontWeight={500}
            textAlign="center"
          >
            {message}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
